var AgreementStatus;

(function (AgreementStatus) {
  AgreementStatus["Active"] = "active";
  AgreementStatus["Amended"] = "amended";
  AgreementStatus["Exhausted"] = "exhausted";
  AgreementStatus["Terminated"] = "terminated";
})(AgreementStatus || (AgreementStatus = {}));

export {};